// @flow
/* eslint-disable react/no-danger */
import React from 'react';

const icon = {
    __html: `
    <svg display="none" width="0" height="0" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <symbol id="svg-minus" viewBox="0 0 50 50">
                <title>minus</title>
                <path d="M0 22.7h50v4.5H0z"/>
            </symbol>
        </defs>
    </svg>
`
};

export const IconMinus = () => <span dangerouslySetInnerHTML={icon} />;

export default IconMinus;
